// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IAuthenticationData {
    static getAttributeTypeMap() {
        return IAuthenticationData.attributeTypeMap;
    }
}
IAuthenticationData.discriminator = undefined;
IAuthenticationData.additionalProperties = false;
IAuthenticationData.attributeTypeMap = [
    {
        "name": "token",
        "baseName": "token",
        "type": "string"
    },
    {
        "name": "sessionId",
        "baseName": "sessionId",
        "type": "number"
    },
    {
        "name": "createDate",
        "baseName": "createDate",
        "type": "Date"
    },
    {
        "name": "expirationDate",
        "baseName": "expirationDate",
        "type": "Date"
    },
    {
        "name": "roles",
        "baseName": "roles",
        "type": ""
    },
    {
        "name": "features",
        "baseName": "features",
        "type": ""
    },
    {
        "name": "username",
        "baseName": "username",
        "type": "string"
    },
];
//# sourceMappingURL=iAuthenticationData.js.map